import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getTemplateDownloadUrl = async (module, accessToken) => {
  const response = await axios.get(
    `${API_BASE_URL}/api/dev/templates/${module}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  const templateData = response.data?.data;

  if (!templateData?.url || !templateData?.filename) {
    throw new Error("Template download response was invalid.");
  }

  return templateData;
};
